export default function login() {
    const login = document.querySelector('#login');
    if (login) {
        const loginError = login.querySelector('#login-error');
        const loginBtn = login.querySelector('.send');
        const passwordField = login.querySelector('#password'); // Campo de senha
        // Função para processar o login
        const processLogin = (event) => {
            event.preventDefault();
            const passInput = passwordField.value;
            const senha = 'MISSVIP';
            const senha2 = 'Missvip';
            const senha3 = 'missvip';
    
            if (passInput === senha || passInput === senha2 || passInput === senha3) {
                const expirationTime = Date.now() + 4 * 60 * 60 * 1000; // 4 horas em milissegundos
                localStorage.setItem('isLoggedIn', 'true'); // Persistir login
                localStorage.setItem('sessionActive', 'true'); // Marcar sessão ativa
                localStorage.setItem('expirationTime', expirationTime); // Armazenar a expiração
                window.location.href = '/'; // Redireciona para a página inicial
            } else {
                loginError.style.display = 'block';
            }
        };
    
        if (loginBtn) {
            // Clique no botão de login
            loginBtn.addEventListener('click', processLogin);
    
            // Pressionar Enter no campo de senha
            passwordField.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    processLogin(event); // Executa diretamente a lógica de login
                }
            });
        }
    }


    // Verifica se o usuário está logado e se a sessão não expirou
    const isLoggedIn = localStorage.getItem('isLoggedIn');
    const expirationTime = localStorage.getItem('expirationTime');

    if (isLoggedIn === 'true' && expirationTime) {
        if (Date.now() < expirationTime) {
            console.log('Está logado');
            const page = document.querySelector('body');
            page.classList.remove('hidden');
        } else {
            // Sessão expirada
            localStorage.removeItem('isLoggedIn');
            localStorage.removeItem('sessionActive');
            localStorage.removeItem('expirationTime');
            const page = document.querySelector('body');
            page.classList.add('hidden');
            window.location.href = '/p/login'; // Redireciona para a página de login
        }
    } else {
        const page = document.querySelector('body');
        if (page.classList.contains('hidden') && window.location.pathname !== '/p/login') {
            window.location.href = '/p/login'; // Redireciona para a página de login
        }
    }
}
